import type { MyTemplate } from "../state/logoStore";
import type { renderLogoSVG } from "./render";

type RenderInput = Parameters<typeof renderLogoSVG>[0];

/**
 * Build a render-ready state object from a saved MyTemplate.
 *
 * Spreads every field from the template (rather than listing fields by hand)
 * so saved-design previews stay in lockstep with the live editor as new fields
 * are added to the store. Title and slogan fall back to caller-provided
 * defaults so empty saves still preview cleanly.
 *
 * The cast strips the MyTemplate-only fields (id / name / savedAt) — they're
 * ignored by renderLogoSVG since they aren't in its accepted Pick.
 */
export function templateToRenderState(
  t: MyTemplate,
  fallbackTitle = "Your Brand",
  fallbackSlogan = "Tagline",
): RenderInput {
  return {
    ...t,
    title: t.title || fallbackTitle,
    slogan: t.slogan || fallbackSlogan,
  } as unknown as RenderInput;
}
